import React, { useState, useEffect } from 'react';
import styles from './actionPopup.module.sass';
import { useSelector, useDispatch } from 'react-redux';
import getSkin from './skin.js';
import { css } from 'aphrodite/no-important';
import applyWrappers from 'wrappers/ComponentWrapper';
import Day from 'svgComponents/day';
import ActionActor from 'commonComponents/actionActor';
import { addElementToArray, removeElementFromArray, checkInRange, shuffleArray } from 'util/functions';
import ActionOptions from 'commonComponents/actionOptions';
import { takeAction } from 'actions/apiActions/action';
import analyticsUtil from 'util/analyticsUtil';
import { updateReduxBackend } from 'actions/apiActions/updateReduxBackend';
import testIds from 'constants/testIds/components/actionPopup';

const ActionPopup = (props) => {

	const sccMetrics = ["strategy", "capability", "culture"];

	const rejectionLabels = {
		1: {
			freq: 'label_action_1_response_rejection_freq_desc',
			limit: 'label_action_1_response_rejection_limit_desc'
		},
		2: {
			freq: 'label_action_2_response_rejection_freq_desc',
			limit: 'label_action_2_response_rejection_limit_desc'
		},
		3: {
			freq: 'label_action_3_response_rejection_freq_desc',
			limit: 'label_action_3_response_rejection_limit_desc'
		},
		4: {
			freq: 'label_action_4_response_rejection_freq_desc',
			limit: 'label_action_4_response_rejection_limit_desc'
		},
		5: {
			freq: 'label_action_5_response_rejection_freq_desc',
			limit: 'label_action_5_response_rejection_limit_desc'
		},
		6: {
			freq: 'label_action_6_response_rejection_freq_desc',
			limit: 'label_action_6_response_rejection_limit_desc'
		},
		7: {
			freq: 'label_action_7_response_rejection_freq_desc',
			limit: 'label_action_7_response_rejection_limit_desc'
		},
		8: {
			freq: 'label_action_8_response_rejection_freq_desc',
			limit: 'label_action_8_response_rejection_limit_desc',
			bu: 'label_action_8_response_rejection_bu_desc'
		},
		9: {
			freq: 'label_action_9_response_rejection_freq_desc',
			limit: 'label_action_9_response_rejection_limit_desc',
			bu: 'label_action_9_response_rejection_bu_desc'
		},
		10: {
			freq: 'label_action_10_response_rejection_freq_desc',
			limit: 'label_action_10_response_rejection_limit_desc'
		},
		11: {
			freq: 'label_action_11_response_rejection_freq_desc',
			limit: 'label_action_11_response_rejection_limit_desc'
		},
		12: {
			freq: 'label_action_12_response_rejection_freq_desc',
			limit: 'label_action_12_response_rejection_limit_desc'
		},
		13: {
			freq: 'label_action_13_response_rejection_freq_desc',
			limit: 'label_action_13_response_rejection_limit_desc'
		},
		14: {
			freq: 'label_action_14_response_rejection_freq_desc',
			limit: 'label_action_14_response_rejection_limit_desc',
			bu: 'label_action_14_response_rejection_bu_desc'
		},
		15: {
			freq: 'label_action_15_response_rejection_freq_desc',
			limit: 'label_action_15_response_rejection_limit_desc'
		},
		16: {
			freq: 'label_action_16_response_rejection_freq_desc',
			limit: 'label_action_16_response_rejection_limit_desc'
		},
		17: {
			freq: 'label_action_17_response_rejection_freq_desc',
			limit: 'label_action_17_response_rejection_limit_desc',
			bu: 'label_action_17_response_rejection_bu_desc'
		},
		18: {
			freq: 'label_action_18_response_rejection_freq_desc',
			limit: 'label_action_18_response_rejection_limit_desc',
			bu: 'label_action_18_response_rejection_bu_desc'
		},
		19: {
			freq: 'label_action_19_response_rejection_freq_desc',
			limit: 'label_action_19_response_rejection_limit_desc'
		},
		20: {
			freq: 'label_action_20_response_rejection_freq_desc',
			limit: 'label_action_20_response_rejection_limit_desc'
		},
		21: {
			freq: 'label_action_21_response_rejection_freq_desc',
			limit: 'label_action_21_response_rejection_limit_desc',
			bu: 'label_action_21_response_rejection_bu_desc'
		}
	};

	const getActionRejectionLabel = (actionId, rejectionType = 'freq') => {
		const actionLabels = rejectionLabels[actionId];
		if (!actionLabels) return '';

		return actionLabels[rejectionType] || actionLabels.freq || '';
	};

	const getRejectionType = () => {

		const selectedAction = myProps.uiState.selectedAction;

		const buRestrictedActions = [4, 7, 8, 9, 14, 17, 18, 21];
		const actionLabels = rejectionLabels[selectedAction];

		if (actionDisabled && actionLabels && actionLabels.bu && buRestrictedActions.includes(selectedAction)) {
			return 'bu';
		}

		if (actionDisabled) return 'limit';

		if (actionRestricted2 || actionRestricted3 ||
			actionRestricted5 || actionRestricted7 || actionRestricted10 ||
			actionRestricted15 || actionRestricted20) {
			return 'freq';
		}

		return 'freq';
	};

	const myProps = useSelector((state) => {
		return {
			uiState: state.uiState,
			actions: state.actions,
			user: state.user,
			actors: state.actors,
			userMetrics: state.userMetrics,
			userActionOptions: state.userActionOptions,
			twoDaysRestrictedActionsList: state.restrictions.twoDaysRestrictedActionsList,
			threeDaysRestrictedActionsList: state.restrictions.threeDaysRestrictedActionsList,
			fiveDaysRestrictedActionsList: state.restrictions.fiveDaysRestrictedActionsList,
			sevenDaysRestrictedActionsList: state.restrictions.sevenDaysRestrictedActionsList,
			tenDaysRestrictedActionsList: state.restrictions.tenDaysRestrictedActionsList,
			fifteenDaysRestrictedActionsList: state.restrictions.fifteenDaysRestrictedActionsList,
			twentyDaysRestrictedActionsList: state.restrictions.twentyDaysRestrictedActionsList,
			permanentDisabledActionList: state.restrictions.permanentDisabledActionList
		};
	});

	const onActionPopupPopupClick = (e) => {
		e.stopPropagation();
	}
	const [actionRestricted2, setActionRestricted2] = useState(false);
	const [actionRestricted3, setActionRestricted3] = useState(false);
	const [actionRestricted5, setActionRestricted5] = useState(false);
	const [actionRestricted7, setActionRestricted7] = useState(false);
	const [actionRestricted10, setActionRestricted10] = useState(false);
	const [actionRestricted15, setActionRestricted15] = useState(false);
	const [actionRestricted20, setActionRestricted20] = useState(false);
	const [actionDisabled, setActionDisabled] = useState(false);
	const [enableAction, setEnableAction] = useState(false);
	const [enableSubmit, setEnableSubmit] = useState(true);
	const [enableOptions, setEnableOptions] = useState(false);
	const [optionId, setOptionId] = useState(null);
	const [poolId, setPoolId] = useState(null);

	const actionDetails = myProps.actions.actionsList.find((eachAction) => {
		return eachAction.id === myProps.uiState.selectedAction;
	});

	const actionOptionDetails = myProps.actions.actionOptionsList.filter((eachOption) => {
		return eachOption.actionId == myProps.uiState.selectedAction && eachOption.isVisible;
	});

	useEffect(() => {
		// Reset all restriction states based on current action
		const selectedAction = myProps.uiState.selectedAction;

		setActionRestricted2(myProps.twoDaysRestrictedActionsList.includes(selectedAction));
		setActionRestricted3(myProps.threeDaysRestrictedActionsList.includes(selectedAction));
		setActionRestricted5(myProps.fiveDaysRestrictedActionsList.includes(selectedAction));
		setActionRestricted7(myProps.sevenDaysRestrictedActionsList.includes(selectedAction));
		setActionRestricted10(myProps.tenDaysRestrictedActionsList.includes(selectedAction));
		setActionRestricted15(myProps.fifteenDaysRestrictedActionsList.includes(selectedAction));
		setActionRestricted20(myProps.twentyDaysRestrictedActionsList.includes(selectedAction));
		setActionDisabled(myProps.permanentDisabledActionList.includes(selectedAction));
	}, [myProps.twoDaysRestrictedActionsList, myProps.threeDaysRestrictedActionsList,
	myProps.fiveDaysRestrictedActionsList, myProps.sevenDaysRestrictedActionsList,
	myProps.tenDaysRestrictedActionsList, myProps.fifteenDaysRestrictedActionsList,
	myProps.twentyDaysRestrictedActionsList, myProps.permanentDisabledActionList, myProps.uiState.selectedAction]
	);

	// Separate useEffect to trigger restrictions calculation when ActionPopup opens
	useEffect(() => {
		dispatch({
			type: 'UPDATE_RESTRICTIONS',
			payload: {
				actionOptionsTakenList: myProps.userActionOptions.userActionOptionList,
				actionOptionsList: myProps.actions.actionOptionsList,
				currentDay: myProps.user.currentDay
			}
		});
	}, [myProps.uiState.selectedAction]); // Only trigger when selectedAction changes

	useEffect(() => {
		const uiState = myProps.uiState;

		const actorsRequiredInRange = checkInRange(uiState.actionSelectedActors.length, uiState.minActorsRequired, uiState.maxActorsRequired);

		if (uiState.isActorSelectionRequired) {

			if (actorsRequiredInRange && !enableOptions) {
				setEnableOptions(true);
			} else if (!actorsRequiredInRange && enableOptions) {
				setEnableOptions(false);
				setOptionId(null);
			}

			if (optionId !== null && actorsRequiredInRange && !enableAction &&
				(!actionRestricted2 || !actionRestricted3 || !actionRestricted5
					|| !actionRestricted7 || !actionRestricted10 || !actionRestricted15
					|| !actionRestricted20 || !actionDisabled)) {
				setEnableAction(true);
			} else if ((!actorsRequiredInRange || optionId === null) && enableAction) {
				setEnableAction(false);
			}
		} else {
			if (!enableOptions) {
				setEnableOptions(true);
			}

			if (optionId !== null && !enableAction && !actionRestricted2 && !actionRestricted3 &&
				!actionRestricted5 && !actionRestricted7 && !actionRestricted10 &&
				!actionRestricted15 && !actionRestricted20 && !actionDisabled) {
				setEnableAction(true);
			}
		}

		if (!enableOptions && props.popupIndex > 50) {
			props.setPopupIndex(50);
		}

		if (actionOptionDetails.length === 1 && (optionId === null || poolId === null)) {
			const actionOption = actionOptionDetails[0];
			let actionOptionPool = null;

			if (actionOption.hasPool && actionOption.actionOptionPool && actionOption.actionOptionPool[0]) {
				actionOptionPool = actionOption.actionOptionPool[0];
			} else if (!actionOption.hasPool) {
				// For actions without pools, create a default pool object
				actionOptionPool = {
					poolId: 0,
					name: actionOption.name,
					description: actionOption.description
				};
			}

			if (actionOptionPool) {
				setOptionId(actionOption.id);
				setPoolId(actionOptionPool.poolId);
			}
		}

	}, [myProps.uiState, enableOptions, enableAction, optionId, props.popupIndex]);

	const removeActor = (id) => {
		let actorList = myProps.uiState.actionSelectedActors;
		actorList = removeElementFromArray(actorList, id);

		analyticsUtil.track('ACTOR_DESELECTED', { actionId: myProps.uiState.selectedAction, actorId: id });

		dispatch({
			type: 'UPDATE_UI_STATE',
			payload: {
				actionSelectedActors: actorList
			}
		});
	}

	const closePopup = () => {
		analyticsUtil.track('POPUP_CLOSED', { popup: myProps.uiState.overlayComponent, type: myProps.uiState.overlayComponentType });
		dispatch({
			type: 'UPDATE_UI_STATE',
			payload: {
				showOverlay: false,
				overlayComponentType: '',
				highlightDesktopHeader: false,
				overlayComponent: '',
				actionSelectedActors: [],
				selectedAction: null,
				highlightActors: false,
				actorSelectionType: '',
				isActorSelectionRequired: false,
				minActorsRequired: 0,
				maxActorsRequired: 0,
				actionDayCost: 0
			}
		});
	}

	const myStyles = getSkin(props.skinGuide);
	const dispatch = useDispatch();

	const getActorDetails = (id) => {
		const actorDetails = myProps.actors.actorsList.find((eachActor) => {
			return eachActor.id === id;
		});
		return actorDetails;
	}

	const renderActorsContainer = () => {
		if (actionRestricted2 || actionRestricted3 || actionRestricted5 || actionRestricted7 || actionRestricted10 || actionRestricted15 || actionRestricted20 || actionDisabled) {
			return (
				<div className={css(myStyles.restrictedActionMessageContainer)} styleName="restricted-action-message-container">
					<div className={css(myStyles.image)} styleName="image">
						<img src={props.getImage('IMG_ACTION_RESTRICTED')} alt={`action-restricted`} width="100%" data-test-id={testIds.RESTRICTED_IMAGE} />
					</div>
					<div className={css(myStyles.description)} styleName="description" data-test-id={testIds.RESTRICTED_MESSAGE_TEXT}>
						{/* {
                            actionDisabled 
                            ? props.getLabel('label_action_1_response_rejection_limit_desc')
                            : props.getLabel(getActionRejectionLabel(myProps.uiState.selectedAction, getRejectionType()))
                        } */}
						{props.getLabel(getActionRejectionLabel(myProps.uiState.selectedAction, getRejectionType()))}
					</div>
				</div>
			)
		}
		let i = 0, j = 0;
		const selectedActors = myProps.uiState.actionSelectedActors;
		let actorDivs = [];
		for (i = 0; i < myProps.uiState.maxActorsRequired; i++) {
			if (j < selectedActors.length) {
				actorDivs.push(
					<ActionActor
						isEmptyActor={false}
						id={selectedActors[j]}
						onDeselect={removeActor}
						actorDetails={getActorDetails(selectedActors[j])}
					/>
				);
				j++;
			} else {
				actorDivs.push(
					<ActionActor
						isEmptyActor={true}
					/>
				)
			}
		}
		return (
			<div className={css(myStyles.actorsContainer)} styleName="actors-container">
				{actorDivs}
			</div>
		);
	}

	const renderOptions = () => {
		if (actionRestricted2 || actionRestricted3 || actionRestricted5 || actionRestricted7 || actionRestricted10 || actionRestricted15 || actionRestricted20 || actionDisabled) {
			return (
				<div className={css(myStyles.restrictedActionMessageContainer)} styleName="restricted-action-message-container">
					<div className={css(myStyles.image)} styleName="image">
						<img src={props.getImage('IMG_ACTION_RESTRICTED')} alt={`action-restricted`} width="100%" data-test-id={testIds.RESTRICTED_IMAGE} />
					</div>
					<div className={css(myStyles.description)} styleName="description" data-test-id={testIds.RESTRICTED_MESSAGE_TEXT}>
						{/* {actionDisabled? props.getLabel('label_action_1_response_rejection_limit_desc') : props.getLabel(getActionRejectionLabel(myProps.uiState.selectedAction, getRejectionType()))} */}
						{props.getLabel(getActionRejectionLabel(myProps.uiState.selectedAction, getRejectionType()))}
					</div>
				</div>
			)
		}
		if (actionOptionDetails.length === 1) {
			return null;
		}
		return (
			<div className={css(myStyles.optionContainer)} styleName="option-container">
				<ActionOptions
					setOptionId={setOptionId}
					setPoolId={setPoolId}
					options={actionOptionDetails}
					optionId={optionId}
					poolId={poolId}
					setPopupIndex={props.setPopupIndex}
					uiDisplayType={actionOptionDetails[0].uiDisplayType}
				/>
			</div>
		);
	}
	const userMetrics = myProps.userMetrics;
	const getAverageAdoption = () => {
		let sum = 0;
		let count = 0;
		sccMetrics.map((eachMetric, index) => {
			const currentMetricId = userMetrics.userMetricIds[eachMetric];
			const userMetricDetails = userMetrics.userMetricsObj[currentMetricId];
			if (userMetricDetails.value) {
				sum += userMetricDetails.value;
				count++;
			}
		});
		if (count === 0) {
			return 0;
		}
		return (sum / count).toFixed(1);
	}

	const submitAction = () => {
		if (!enableAction) {
			return;
		}
		if (!enableSubmit) {
			return;
		}
		setEnableSubmit(false);
		const optionDetails = myProps.actions.actionOptionsList.find((eachOption) => {
			return optionId == eachOption.id;
		})
		const payload = {
			actionOptionId: optionId,
			poolId: poolId,
			actorIds: myProps.uiState.actionSelectedActors,
			route: optionDetails.route,
			currentDay: myProps.user.currentDay,
			currentAverageAdoption: getAverageAdoption()
		};
		// if([7].includes(myProps.uiState.selectedAction)){
		// 	dispatch({
		// 		type:'UPDATE_DISABLED_ACTORS_NO_CONDITION',
		// 		payload:{
		// 			actorsSelected: myProps.uiState.actionSelectedActors,
		// 			actionId: myProps.uiState.selectedAction
		// 		}
		// 	});
		// 	dispatch(updateReduxBackend("DISABLE_ACTION_ACTOR"));
		// }
		dispatch(takeAction(payload, closePopup));
		//Suffle actionOptions after any action is taken
		setTimeout(() => {
			shuffleArray(myProps.actions.actionOptionsList);
		}, 1000);
	}

	const renderSurveyQuestions = () => {
		if (actionRestricted2 || actionRestricted3 || actionRestricted5 || actionRestricted7 || actionRestricted10 || actionRestricted15 || actionRestricted20 || actionDisabled) {
			return;
		}
		const questionList = actionOptionDetails[0].surveyJson.data.list;
		const questionListDiv = questionList.map((eachQuestion, index) => {
			return (
				<div key={index} className={css(myStyles.eachSqQuestion)} styleName="each-sq-question" data-test-id={testIds.SURVEY_QUESTION_TEXT}>
					{index + 1}. {props.getLabel(eachQuestion)}
				</div>
			);
		});
		if (questionListDiv.length === 0) {
			return null;
		}
		return (
			<div className={css(myStyles.sqContainer)} styleName="sq-container">
				<div className={css(myStyles.sqHeading)} styleName="sq-heading" data-test-id={testIds.SURVEY_HEADING_TEXT}>{props.getLabel('label_survey_questions')}</div>
				<div styleName="sq-questions">
					{questionListDiv}
				</div>
			</div>
		);
	}

	return (
		<div className={css(myStyles.container)} styleName="container" onClick={onActionPopupPopupClick} data-test-id={testIds.CONTAINER}>
			<div className={css(myStyles.header)} styleName="header">
				<div className={css(myStyles.image)} styleName="image">
					<img src={props.getImage(actionDetails.image)} alt={`action-img-${actionDetails.id}`} width="100%" data-test-id={testIds.ACTION_IMAGE} />
				</div>
				<div className={css(myStyles.text)} styleName="text" data-test-id={testIds.ACTION_TITLE_TEXT}>
					{props.getLabel(actionDetails.name)}
				</div>
			</div>
			<div className={css(myStyles.description)} styleName="description" data-test-id={testIds.ACTION_DESCRIPTION_TEXT}>
				{props.getLabel(actionDetails.description)}
			</div>
			<div styleName="day-container">
				<div styleName="day-image" data-test-id={testIds.DAY_ICON}>
					<Day />
				</div>
				<div className={css(myStyles.dayText)} styleName="day-text" data-test-id={testIds.DAY_COST_TEXT}>
					{myProps.uiState.actionDayCost} {props.getLabel('label_days')}
				</div>
			</div>
			{
				actionOptionDetails[0] && actionOptionDetails[0].isSurveyAvailable
					? renderSurveyQuestions()
					: null
			}
			{
				myProps.uiState.isActorSelectionRequired
					? renderActorsContainer()
					: null
			}
			{
				enableOptions
					? renderOptions()
					: null
			}
			<div className={css(myStyles.footer)} styleName="footer">
				<div
					onClick={closePopup}
					className={css(myStyles.cancel)}
					styleName="cancel"
					data-test-id={testIds.CANCEL_BUTTON_CLICK}>
					{props.getLabel('label_cancel')}
				</div>
				<div
					className={enableAction ? css(myStyles.proceed) : css(myStyles.proceedDisable)}
					styleName="proceed"
					onClick={submitAction}
					data-test-id={testIds.PROCEED_BUTTON_CLICK}>
					{props.getLabel('label_proceed')}
				</div>
			</div>
		</div>
	);
}

export default applyWrappers(ActionPopup, styles);
